import React, { useState, useEffect, useContext,useMemo} from "react";
import ParkingServices from "services/ParkingServices";
import useAsync from "hooks/useAsync";
// import DeleteModal from "components/modal/DeleteModal"; 
import ParkingDeleteModal from "components/modal/ParkingDeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import sidebar from "routes/sidebar";
import { SidebarContext } from "context/SidebarContext";
import MainDrawer from "components/drawer/MainDrawer";
import ParkingDrawer from "components/drawer/ParkingDrawer";
import { FiRefreshCcw, FiPlus } from "react-icons/fi";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import ParkingTable from "components/parking/parkingTable";
import useFilter from "hooks/useFilter";
import UploadData from "components/common/UploadData";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";

const Parking = () => {
  const [safeData, setSafeData] = useState([]);
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const { toggleDrawer, setIsUpdate, isUpdate } = useContext(SidebarContext);
  const [status, setStatus] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);


  const [searchValue, setSearchValue] = useState("");

  const { data, loading, error } = useAsync(() =>
    ParkingServices.getAllParking()
  );
  // console.log("data from safedata", data);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setSafeData(data);
    }
  }, [data]);

  useEffect(() => {
    if (isUpdate) {
      ParkingServices.getAllParking().then((freshData) => {
        setSafeData(freshData || []);
        setIsUpdate(false);
      });
    }
  }, [isUpdate, setIsUpdate]);
const filteredParking = useMemo(() => {
  if (!searchValue) return safeData;
  const val = searchValue.toLowerCase();
  return safeData.filter(item =>
    item.city_name?.toLowerCase().includes(val) ||
    item.sight_seeing?.toLowerCase().includes(val) ||
    Object.values(item.costs || {}).some(v => String(v).toLowerCase().includes(val))
  );
}, [safeData, searchValue]);
useEffect(() => {
  if (filteredParking.length > 0) {
    setItemsPerPage(filteredParking.length);
  }

}, [filteredParking]);

  const isAdmin = adminInfo?.id === 1;
  const hideView =
    isAdmin ||
    adminInfo?.permission?.some((p) => p.id_tab === "parking" && p.view === 1);
  const hideDelete =
    isAdmin ||
    adminInfo?.permission?.some(
      (p) => p.id_tab === "parking" && p.delete === 1
    );
  const hideEdit =
    isAdmin ||
    adminInfo?.permission?.some((p) => p.id_tab === "parking" && p.edit === 1);
  const hideExport =
    isAdmin ||
    adminInfo?.permission?.some(
      (p) => p.id_tab === "parking" && p.export === 1
    );
  const hideAdd =
    isAdmin ||
    adminInfo?.permission?.some((p) => p.id_tab === "parking" && p.add === 1);
  const hideUpload =
    isAdmin ||
    adminInfo?.permission?.some(
      (p) => p.id_tab === "parking" && p.upload === 1
    );

  const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
    useToggleDrawer();
  const { dataTable, ParkingRef, handleSubmitParking } = useFilter(
    filteredParking,
    itemsPerPage
  );



  const csvDataArray = [
    ["SI.No", "City", "Sight Seeing", "Entry", "Timing", "Sedan", "SUV & MUV", "Tempo Traveller"],
    ...filteredParking.map(({ city_name, sight_seeing, entry, timing, costs }, index) => [
      index + 1,
      city_name,
      sight_seeing,
      entry,
      timing,
      costs?.Sedan ?? "",
      costs?.["Suv & Muv"] ?? "",
      costs?.["Tempo Traveller"] ?? "",
    ]),
  ];

  const [headers, ...rows] = csvDataArray;

  const csvData = rows.map(row =>
    headers.reduce((acc, header, i) => {
      acc[header] = row[i];
      return acc;
    }, {})
  );

  const refreshParkingList = () => {
    setIsUpdate(true);
  };

  const handleRefresh = () => setIsUpdate(true);

  return (
    <>
      {hideView && (
        <>
          <ParkingDeleteModal id={serviceId} title={title} />
          <PageTitle sidebar={sidebar().sidebar} />
          <MainDrawer>
            <ParkingDrawer id={serviceId} title={title} />
          </MainDrawer>

          <Card className="shadow-xs bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <form
                className="flex gap-6 items-center"
                onSubmit={handleSubmitParking}
              >
                <div className="flex-1">
                  <Input
                    ref={ParkingRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={(e) => setSearchValue(e.target.value)}

                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Parking
                  </Button>
                )}

                {hideUpload && <UploadData onUploaded={refreshParkingList} />}

                {hideExport && (
                  <ExportDataXlsx
                    title="Parking"
                    exportDataXlsx={csvData}
                    fileNames="Parking List"
                  />
                )}

                <FiRefreshCcw onClick={handleRefresh} cursor="pointer" />
              </form>
            </CardBody>
          </Card>

          <div className="data-table-container">
            <DataWrapper loading={loading} error={error} status={status}>
              {filteredParking?.length > 0 ? (
                <TableContainer
                  className="mb-8"
                  style={{
                    maxHeight: "65vh",
                    overflowY: "scroll",
                    scrollbarWidth: "thin",
                  }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                      <tr>
                        <TableCell className="text-center">Sl.No.</TableCell>
                        <TableCell className="text-center">City</TableCell>
                        <TableCell className="text-center">
                          Sight Seeing Place
                        </TableCell>
                        {/* <TableCell className="text-center">Start Time</TableCell> */}
                        {/* <TableCell className="text-center">End Time</TableCell> */}
                        <TableCell className="text-center">Sedan</TableCell>
                        <TableCell className="text-center">
                          Suv/Muv/Crysta
                        </TableCell>
                        <TableCell className="text-center">
                          Tempo Traveller
                        </TableCell>
                        <TableCell className="text-center">Actions</TableCell>
                      </tr>
                    </TableHeader>

                    <ParkingTable
                      parkingdata={dataTable}
                      isSubmitting={isSubmitting}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </TableContainer>
              ) : (
                <div
                  className="mb-8 flex items-center justify-center"
                  style={{ minHeight: "65vh" }}
                >
                  <NotFound title="No Parking Records Found." />
                </div>
              )}
            </DataWrapper>
          </div>
        </>
      )}
    </>
  );
};

export default Parking;
